import { createContext } from 'react';
import { Lang, defaultLang } from './strings';

export interface I18nCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
}

export const I18nContext = createContext<I18nCtx>({ lang: defaultLang, setLang: () => {} });
